<template>
  <AppLayout>
    <!-- Rezerwacje -->
    <template #subheader>
      <div class="d-flex align-items-center justify-content-between w-100 flex-wrap gap-3">

        <!-- PRAWA STRONA -->
        <div class="d-flex align-items-center me-2">
          <Link
              v-if="isAdmin()"
              class="btn btn-sm btn-outline-primary"
              :href="route('articleWarehouses.index')"
          >
            Magazyny
          </Link>
        </div>

      </div>
    </template>


    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading d-block">
          <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.flash.errors">
            <li class="alert alert-danger">{{ error }}</li>
          </ul>
        </div>

        <div class="widget-content">
          <div>
            <ejs-grid ref="warehouseReservationGrid" id="warehouseReservationGridId" height="60vh"
                      :dataSource="warehouseReservationsDataManager"
                      :allowTextWrap='false'
                      :allowExcelExport='true'
                      :allowPdfExport='true'
                      :allowPaging="true"
                      :allowSorting='true'
                      :allowFiltering='true'
                      :allowReordering='true'
                      :allowResizing='true'
                      :showColumnChooser='true'
                      :allowSelection='true'
                      :enablePersistence='true'
                      :pageSettings="pageSettings"
                      :editSettings="editSettings"
                      :selectionSettings="selectionOptions"
                      :filterSettings="filterOptions"
                      :toolbar="toolbar"
                      :contextMenuItems="contextMenuItems"
                      @contextMenuOpen="onContextMenuOpen"
                      :rowSelecting="rowSelecting"
                      :rowSelected="onRowSelected"
					  :rowDataBound="onRowDataBound"
					  :rowHeight="32"
                      :toolbarClick="clickToolbarHandler"
                      :contextMenuClick="clickContextMenuHandler">
              <e-columns>
                <e-column type="checkbox" width="100"/>
                <e-column field="id" headerText="ID" :allowEditing="false" isPrimaryKey="true"
                          :visible="false"/>
				<e-column field="project_number" headerText="Projekt" :filter="filterDefault"/>
                <e-column field="article_catalog_number" headerText="Nr artykułu" type="string"
                          :filter="filterDefault"/>
                <e-column field="article_model" headerText="Model artykułu" type="string"
                          :filter="filterDefault"/>
               <e-column field="article_description" headerText="Nazwa/Opis" width="200" type="string"
                          :filter="filterDefault"/>
                <e-column field="producer_id" headerText="Producent" headerTooltip="Producent"
                          foreignKeyValue="name" foreignKeyField="id" :dataSource="producers"
                          :allowEditing="false" :allowSorting="true" :allowFiltering="true" :filter="filterProducers" :valueAccessor="producerValueAccessor"/>
                <e-column field="article_unit.name" headerText="J.m." type="string" :filter="filterDefault"/>
                <e-column field="quantity_reserved" headerText="Zarezerwowane" format="N2" type="number"
                          :filter="filterNumeric"/>
 				<e-column field="quantity_to_order" headerText="Ilość do zam." :allowEditing="false" type="number" format="N2" :filter="filterNumeric" textAlign="Right"/>
               <e-column field="article_location" headerText="Lokalizacja" type="string"
                          :filter="filterDefault"/>
                <e-column field="warehouse_items" headerText="Ilość na stanie" format="N2" type="number"
                          :filter="filterNumeric"/>		  
                <e-column field="created_by_name" headerText="Utworzony przez" type="string" :filter="filterDefault"/>
                 <e-column field="article_details" headerText="Szczegóły" :filter="filterDefault"/>
                <e-column field="required_project_item_id" headerText="Zapotrzebowanie projektowe"
                          :filter="filterNumeric" type="number"/>
                <e-column field="fulfilled_quantity" headerText="Wydana ilość" format="N2" type="number"
                          :filter="filterNumeric"/>
                <e-column field="status" headerText="Status" type="string" :filter="filterStatuses"/>
                <e-column field="created_at" headerText="Data utworzenia"
                          :customFormat="{type:'date', format: 'dd.MM.yyyy'}" :filter="filterDefault"/>
              </e-columns>
            </ejs-grid>
          </div>

          <ChangeStatusModal ref="changeStatusModalRef"
                             @status-updated-success="successMsg"
                             @status-updated-error="errorMsg"
                             @refresh="this.$refs.warehouseReservationGrid.refresh()"
                             :statuses="statuses"
                             :selectedRecords="selectedRecords"
							 @clear-selection="clearSelection"/>

<DispositionReservationModal
  ref="dispositionReservationModalRef"
  @updated-success="successMsg"
  @updated-error="errorMsg"
  @refresh="this.$refs.warehouseReservationGrid.refresh()"
  @closed="onDispositionClosed"
  :selectedRecords="selectedRecordsToDisposition"
  @clear-selection="clearSelection"
/>


        </div>
      </div>
    </div>


  </AppLayout>
</template>

<script>
import AppLayout from "../../../Layouts/App.vue";
import {usePage} from "@inertiajs/vue3";
import {MultiSelect} from '@syncfusion/ej2-vue-dropdowns';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  ExcelExport,
  PdfExport,
  Filter,
  ForeignKey,
  GridComponent,
  Page,
  Print,
  Reorder,
  Resize,
  Sort,
  Toolbar,
  Group
} from '@syncfusion/ej2-vue-grids';
import {createElement} from "@syncfusion/ej2-base";
import {DataManager, WebMethodAdaptor} from '@syncfusion/ej2-data';
import {DropDownList} from "@syncfusion/ej2-dropdowns";

import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import ChangeStatusModal from "./ChangeStatusModal.vue";
import DispositionReservationModal from "./DispositionReservationModal.vue";

const {hasRole, hasPermission} = usePermission();


let dropInstanceFilterUnits, statusElem, statusObj;
export default {

  components: {
    DispositionReservationModal,
    ChangeStatusModal,
    hasPermission,
    AppLayout,
    MultiSelect,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },

  provide: {
    grid: [Page, Edit, Toolbar, ContextMenu, Sort, Filter, Reorder, Print, Resize, ColumnChooser, ExcelExport, PdfExport, ForeignKey, Group]
  },

  props: {
    users: Object,
    statuses: Array,
	producers: Object,
	table_settings: {
		type: Object,
		default: null
	},	
	now_restore_table: {
		type: Number,
		default: 1
	}
  },

  beforeMount() {
    this.getReservations();
  },

  mounted() {
	this.restoreTableIfNeeded();
    this.$nextTick(() => {
      const grid = this.$refs.warehouseReservationGrid?.ej2Instances;
      if (!grid) return;

      const gridEl = grid.element;

      gridEl.addEventListener('mousedown', (e) => {
        if (e.which === 3) { // PPM
          this.preventRightClickSelection = true;
        }
      }, true);
    });
  },

  data() {
    return {
	  tableSettingsApplied: false,
	  hasTableSettings: false,
      hasPermission,
      preventRightClickSelection: false,
      isPrinting: false,
      warehouseReservationsDataManager: [],
      selectedRecords: null,
      selectedRecordsToDisposition: null,
      selectionOptions: {checkboxOnly: true, persistSelection: true},
      pageSettings: {pageSize: 30, pageCount: 5, pageSizes: [10, 20, 30, 50, 100]},
      filterOptions: {
        type: "Menu",
        operator: 'contains'
      },
      filterDefault: {operator: 'contains', params: {minLength: 2}},
      filterNumeric: {operator: 'equal'},
      toolbar: this.getToolbar(),
      editSettings: this.getEditSettings(),
      contextMenuItems: this.getContextMenu(),
      filterWarehouses: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.warehouses,
              fields: {text: 'short_name', value: 'id'},
              placeholder: 'Szukaj magazynu',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterStatuses: {
        operator: 'equal',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.statuses,
              placeholder: 'Wybierz status',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },
      filterProducers: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.producers,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj producentów',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },
      filterLocations: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.locations,
              fields: {text: 'short_name', value: 'id'},
              placeholder: 'Szukaj magazynu',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterCreatedBy: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.users,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj kto stworzył',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },


      orderItemWarehousesParams: {
        create: () => {
          statusElem = document.createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.text;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: () => {
          statusObj = new DropDownList({
            dataSource: this.warehouses,
            fields: {value: 'id', text: 'short_name'},
            enabled: true,
            placeholder: 'Wybierz magazyn',
            floatLabelType: 'Never',
            change: async (event) => {
              statusObj.value = await this.onChangeWarehouse(event);
            }
          });
          statusObj.appendTo(statusElem);
        }
      }
    };
  },
    watch: {
        table_settings: {
            immediate: true,
            deep: true,
            handler(value) {
                this.hasTableSettings = !!(value?.settings);

                this.$nextTick(() => {
                    const grid = this.$refs.warehouseReservationGrid?.ej2Instances;

                    if (grid) {
                        grid.toolbar = this.getToolbar();
                    }
                });
            }
        }
    },
  methods: {
  

  
		  restoreTableIfNeeded() {
			if (this.now_restore_table !== 0) {
			  return;
			}

			let grid = this.$refs.warehouseReservationGrid;

			if (!grid || !grid.$el || !grid.ej2Instances) {
			  return;
			}
			let gridName = 'grid' + grid.$el.id;
			grid.ej2Instances.enablePersistence = false;
			window.localStorage.setItem(gridName, "");
			grid.ej2Instances.destroy();
			(function stripIdsFromUrl() {
			  try {
				const url = new URL(window.location.href);
				url.searchParams.delete('ids');
				url.searchParams.delete('ids[]');
				history.replaceState(
				  history.state,
				  '',
				  url.toString()
				);
			  } catch (e) {
				const href = window.location.href;
				const cleaned = href
				  .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
				  .replace(/[?&]$/, '');
				history.replaceState(
				  history.state,
				  '',
				  cleaned
				);
			  }
			})();
			this.applyTableSettings();
			location.reload();
	},  
        applyTableSettings() {
            const grid = this.$refs.warehouseReservationGrid?.ej2Instances;

            if (!grid || !this.table_settings?.settings) {
                return;
            }

            let settings;

            try {
                settings = JSON.parse(this.table_settings.settings);
            } catch (error) {
                console.error('Błąd odczytu ustawień tabeli:', error);
                return;
            }

            if (!Array.isArray(settings)) {
                return;
            }

            settings.forEach(setting => {
                if (!setting.field) {
                    return;
                }

                const column = grid.columns.find(
                    col => col.field === setting.field
                );

                if (!column) {
                    return;
                }

                if (setting.width !== undefined) {
                    column.width = setting.width;
                }

                column.visible = setting.visible !== false;
            });

            grid.refreshColumns();

            const savedFields = settings
                .filter(setting => setting.field)
                .sort((a, b) => a.index - b.index)
                .map(setting => setting.field);
            const currentFields = grid.columns
                .filter(column => column.field)
                .map(column => column.field);

            savedFields.forEach((field, targetIndex) => {
                const currentIndex = currentFields.indexOf(field);

                if (currentIndex === -1 || currentIndex === targetIndex) {
                    return;
                }

                const targetField = currentFields[targetIndex];

                if (!targetField) {
                    return;
                }

                grid.reorderColumns(
                    field,
                    targetField
                );

                currentFields.splice(currentIndex, 1);
                currentFields.splice(targetIndex, 0, field);
            });

            grid.refreshColumns();
        },	
    clearSelection() {
    this.selectedRecordsToDisposition = [];
	this.selectedRecordsToDisposition = [];

	  this.$nextTick(() => {
    const grid = this.$refs.warehouseReservationGrid?.ej2Instances;

    if (!grid) return;

    grid.clearSelection();
    grid.refresh(); 
  });
  
  
},

producerValueAccessor(field, data) {
    return data?.name ?? '';
},
      resolveProducerName(id) {
      if (!id) return '';
      const p = this.producers?.find(x => String(x.id) === String(id));
      return p?.name ?? '';
    },
onDispositionClosed() {
  this.selectedRecordsToDisposition = [];
  const grid = this.$refs.warehouseReservationGrid?.ej2Instances;
  if (grid) {
    grid.clearSelection();
  }
},
  
    getEditSettings() {
      return {
        allowEditing: false,
        allowAdding: false,
        allowDeleting: true,
        showConfirmDialog: false,
        showDeleteConfirmDialog: false,
        mode: 'Batch',
        newRowPosition: 'Top'
      };
    },
        getToolbar() {
            const tools = [];
            tools.push(
                {text: "Usuń", prefixIcon: 'e-trash', id: 'delete_btn'},
                {text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters'},
				{text: "Search", prefixIcon: 'e-search', id: "search", align: 'center'},
                {text: "Zapisz ustawienia", prefixIcon: 'e-save', id: "save", align: 'right' });
            if (this.hasTableSettings) {
                tools.push({ text: "Usuń ustawienia", prefixIcon: 'e-delete', id: "delete-set", align: 'right' });
            }
            tools.push({text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right'},
        {text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right'},
        {text: 'Drukuj', prefixIcon: 'e-print', id: "warehouseReservationGridId_prt", align: "right"},
        "ColumnChooser"
            );

            return tools;
        },

    clickToolbarHandler: async function (args) {
      if (args.item.id === 'delete_btn') {
        const grid = this.$refs.warehouseReservationGrid?.ej2Instances;
        if (!grid) return;
        const selectedRecords = grid.getSelectedRecords();

        if (!selectedRecords || selectedRecords.length === 0) return;

const ids = selectedRecords
  .map(record => record.id)
  .filter(id => id !== undefined && id !== null);

console.log('[DELETE RESERVATIONS] ID do usunięcia:', ids);

if (!ids.length) {
  this.errorMsg('Zaznaczone rekordy nie zawierają ID rezerwacji.');
  return;
}

        Toast.fire({
          toast: false,
          icon: 'warning',
          title: 'Usuwanie rezerwacji',
          html: 'Czy na pewno chcesz usunąć zaznaczone rezerwacje?',
          showDenyButton: true,
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: false,
          position: 'center',
          showConfirmButton: true,
          confirmButtonText: 'Tak',
          denyButtonText: 'Nie'
        }).then((result) => {
          if (result.isConfirmed) {
axios.delete(route('warehouse-reservations.delete'), {
  data: {
    reservation_ids: ids
  }
}).then(response => {
  this.successMsg(response.data.message);
  grid.refresh();
}).catch(error => {
  console.error('[DELETE RESERVATIONS] Błąd:', {
    status: error.response?.status,
    data: error.response?.data,
    ids
  });

  this.errorMsg(
    error.response?.data?.error ?? 'Błąd podczas usuwania rezerwacji.'
  );
});
			this.clearSelection();
          }
        });
      }

      if (args.item.id === 'reset_filters') {
        this.$refs.warehouseReservationGrid.clearFiltering();
      }

            if (args.item.id === 'save') {
                const grid = this.$refs.warehouseReservationGrid?.ej2Instances;

                if (!grid) {
                    console.warn('Grid nie został znaleziony');
                    this.errorMsg("Konfiguracja tabeli nie została zapisana!");
                    return;
                }
                const tableId = 'warehouseReservationGrid';
                const settings = grid.columns.map((column, index) => ({
                    field: column.field || null,
                    index: index,
                    width: column.width,
                    visible: column.visible !== false
                }));
                try {
                    const response = await axios.post('/table-settings', {
                        tableId: tableId,
                        columns: JSON.stringify(settings)
                    });
                    this.hasTableSettings = true;
                    grid.toolbar = this.getToolbar();
                    this.successMsg("Konfiguracja tabeli została pomyślnie zapisana!");
                } catch (error) {
                    this.errorMsg("Konfiguracja tabeli nie została zapisana!");
                }
            }
            if (args.item.id === 'delete-set') {
                const tableId = 'warehouseReservationGrid';
                try {
                    const response = await axios.delete('/table-settings-delete', {
                        data: {
                            tableId: tableId
                        }
                    }
                    );
                    this.hasTableSettings = false;
                    const grid = this.$refs.warehouseReservationGrid?.ej2Instances;

                    if (grid) {
                        grid.toolbar = this.getToolbar();
                    }
                    this.successMsg(
                        "Konfiguracja tabeli została pomyślnie usunięta!"
                    );
                } catch (error) {
                    this.errorMsg(
                        "Konfiguracja tabeli nie została usunięta!"
                    );
                }
            }
      if (args.item.id === 'restore') {
        let grid = this.$refs.warehouseReservationGrid;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();
		this.applyTableSettings();
        location.reload();
      }

      if (args.item.id === 'excelexport') {
        this.$refs.warehouseReservationGrid.excelExport({
          fileName: `Rezerwacje.xlsx`
        });
      }

      if (args.item.id === 'warehouseReservationGridId_prt') {
        this.printGrid();
      }

    },

    getContextMenu() {
      return [
        {text: 'Zmień status', target: '.e-content', id: 'change_status'},
        {separator: true},
        {text: 'Dyspozycja rezerwacji', target: '.e-content', id: 'reservation_disposition'}
      ];
    },

    clickContextMenuHandler(args) {
	  args.event?.preventDefault();
  args.event?.stopPropagation();
  
      if (args.item.id === 'change_status') {
        this.$nextTick(() => {
          this.selectedRecords = this.$refs.warehouseReservationGrid.getSelectedRecords();
          this.$refs.changeStatusModalRef.show();
        });
      }

if (args.item.id === 'reservation_disposition') {
  this.$nextTick(() => {
    const selected = [
      ...this.$refs.warehouseReservationGrid.getSelectedRecords()
    ];
    this.selectedRecordsToDisposition = selected;
    this.$refs.dispositionReservationModalRef.show();
  });
}
    },

    onContextMenuOpen(args) {
      const grid = this.$refs.warehouseReservationGrid?.ej2Instances;
      if (!grid) return;

      const selected = grid.getSelectedRecords() || [];

      // klik nie w wiersz → nie pokazuj menu
      const rowInfo = grid.getRowInfo(args.event.target);
      if (!rowInfo?.rowData) {
        args.cancel = true;
        return;
      }

      // brak zaznaczenia → nie pokazuj menu
      if (!selected.length) {
        args.cancel = true;
      }
    },


    rowSelecting(args) {
      if (this.preventRightClickSelection) {
        args.cancel = true;
        this.preventRightClickSelection = false;

      }
    },

    onRowSelected(args) {
      this.selectedDocument = args.data ?? {};
    },
        onRowDataBound(args) {
            if (!this.tableSettingsApplied) {
                this.tableSettingsApplied = true;
                this.applyTableSettings();
            }
        },
    getReservations() {
      this.warehouseReservationsDataManager = new DataManager({
        url: route('warehouse-reservations.getGroupedList'),
        adaptor: new WebMethodAdaptor(),
        crossDomain: true,
        headers: [
          {'X-CSRF-TOKEN': usePage().props.csrf_token}
        ]
      });
    },

    isAdmin() {
      return hasRole('ADMIN');
    },

printGrid() {
  const grid = this.$refs.warehouseReservationGrid?.ej2Instances;
  if (!grid || this.isPrinting) return;

  this.isPrinting = true;

  const records = grid.getCurrentViewRecords();

  const columns = [
    { field: 'project_number', header: 'Projekt' },
    { field: 'article_catalog_number', header: 'Nr artykułu' },
    { field: 'article_model', header: 'Model artykułu' },
    { field: 'producer_id', header: 'Producent' },
    { field: 'article_unit.name', header: 'J.m.' },
    { field: 'quantity_reserved', header: 'Ilośc zarez.' },
    { field: 'quantity_to_order', header: 'Ilość do zam.' },
    { field: 'article_location', header: 'Lok.' },
    { field: 'warehouse_items', header: 'Ilość na stanie' },
    { field: 'required_project_item_id', header: 'Nr zap. proj.' },
    { field: 'fulfilled_quantity', header: 'Wydana ilość' }
  ];

  const getValue = (row, field) => {
    if (field === 'producer_id') {
      const producer = this.producers.find(p => p.id === row.producer_id);
      return producer ? producer.name : '';
    }

    if (field === 'article_unit.name') {
      return row.article_unit?.name ?? '';
    }

    return row[field] ?? '';
  };

  let html = `
  <html>
  <head>
    <title>Rezerwacje</title>
    <style>
      @page {
        size: landscape;
        margin: 10mm;
      }

      body {
        font-family: Arial, sans-serif;
        font-size: 10px;
      }

      h2 {
        text-align: center;
        margin-bottom: 15px;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        table-layout: auto;
      }

      th {
        background: #eee;
        font-weight: bold;
      }

      th, td {
        border: 1px solid #999;
        padding: 4px;
        text-align: left;
      }

      td {
        white-space: nowrap;
      }
    </style>
  </head>

  <body>

  <h2>Rezerwacje</h2>

  <table>
    <thead>
      <tr>
  `;

  columns.forEach(col => {
    html += `<th>${col.header}</th>`;
  });

  html += `
      </tr>
    </thead>
    <tbody>
  `;

  records.forEach(row => {
    html += '<tr>';

    columns.forEach(col => {
      let value = getValue(row, col.field);

      if (
        [
          'quantity_reserved',
          'quantity_to_order',
          'warehouse_items',
          'fulfilled_quantity'
        ].includes(col.field)
      ) {
        value = Number(value ?? 0).toFixed(2);
      }

      html += `<td>${value}</td>`;
    });

    html += '</tr>';
  });

  html += `
    </tbody>
  </table>

  </body>
  </html>
  `;


  const printWindow = window.open('', '_blank');

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.print();
    printWindow.close();
  };

  this.isPrinting = false;
},

    successMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'success',
        title: 'Sukces!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  }
};
</script>

<style scoped>
.not-editable {
  color: orangered;
}
</style>

<style>
@media print {
  .e-grid {
    border-left: none !important;
    border-right: none !important;
  }

  .e-grid .e-headercell,
  .e-grid .e-headertext {
    font-weight: 700 !important;
    color: black !important;
  }

  .e-gridheader {
    position: static !important;
    top: auto !important;
  }
}
</style>